export interface IReportRow {
  date: string;
  agreementId: string;
  agreementName: string;
  agreementTargetType: 'BRAND' | 'CONNECTOR';
  // brand of the transaction's integration (a connector agreement spans several)
  paymentBrandName: string;
  merchantId: string;
  merchantName: string;
  parentId: string | null;
  parentName: string | null;
  grandparentId: string | null;
  grandparentName: string | null;
  amount: number;
  surcharge: number;
  amountInInvoicingCurrency: number;
  transactionCurrency: string;
  bips: number;
  invoicingCurrency: string;
  referralFee: number;
}

export interface IReportResult {
  rows: IReportRow[];
  totalVolume: number;
  estReferralFee: number;
  uniqueMerchants: number;
  avgBips: number;
  rowCount: number;
  displayCurrency: string;
}

export interface IEntityOption {
  id: string;
  name: string;
}

export function getDefaultDates(): { from: string; to: string } {
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  return { from: `${year}-${month}-01`, to: `${year}-${month}-${day}` };
}

const BRAND_COLORS = [
  '#1a1a2e', '#c8102e', '#006341', '#e94560',
  '#0f3460', '#533483', '#00704a', '#4a1942',
  '#2c3e50', '#16a085', '#8e44ad', '#1e40af',
];

export function brandColor(name: string): string {
  if (!name) return '#6B7280';
  let idx = 0;
  for (let i = 0; i < name.length; i += 1) {
    idx = (idx + name.charCodeAt(i)) % BRAND_COLORS.length;
  }
  return BRAND_COLORS[idx];
}

export function fmtCurrency(amount: number | null | undefined, currency: string): string {
  if (amount == null) return '—';
  try {
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency, minimumFractionDigits: 2,
    }).format(amount);
  } catch {
    return `${currency} ${amount.toFixed(2)}`;
  }
}

export function downloadCSV(rows: IReportRow[]) {
  const header = 'Date,Agreement,Brand,Merchant,Parent,Grandparent,Amount,TxCurrency,AmountInvoicingCcy,InvoicingCurrency,BiPs,Ref.Fee';
  const lines = rows.map((r) => [
    r.date,
    `"${r.agreementName}"`,
    `"${r.paymentBrandName}"`,
    `"${r.merchantName}"`,
    `"${r.parentName ?? ''}"`,
    `"${r.grandparentName ?? ''}"`,
    r.amount + r.surcharge,
    r.transactionCurrency,
    r.amountInInvoicingCurrency,
    r.invoicingCurrency,
    r.bips,
    r.referralFee,
  ].join(','));
  const csv = [header, ...lines].join('\n');
  const blob = new Blob([csv], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `referral-reporting-${Date.now()}.csv`;
  a.click();
  URL.revokeObjectURL(url);
}
